<div class="cookie-banner-wrapper" *ngIf="isVisible">
  <!-- Main Banner -->
  <aside class="cookie-banner" aria-label="Cookie consent banner" role="region">
    <div class="cookie-banner-content">
      <div class="cookie-banner-text">
        <h3 class="cookie-banner-title">{{ 'COOKIE_BANNER.TITLE' | translate }}</h3>
        <p class="cookie-banner-desc">
          {{ 'COOKIE_BANNER.DESCRIPTION' | translate }}
          <a [routerLink]="['/cookie']" class="cookie-link">{{ 'COOKIE_BANNER.COOKIE_POLICY' | translate }}</a>
          {{ 'COOKIE_BANNER.AND' | translate }}
          <a [routerLink]="['/privacy']" class="cookie-link">{{ 'COOKIE_BANNER.PRIVACY_POLICY' | translate }}</a>.
        </p>
      </div>

      <div class="cookie-banner-actions">
        <button mat-button type="button" class="btn-preferences" (click)="openPreferences()">
          {{ 'COOKIE_BANNER.PREFERENCES' | translate }}
        </button>
        <button mat-stroked-button type="button" class="btn-necessary" (click)="acceptNecessary()">
          {{ 'COOKIE_BANNER.NECESSARY_ONLY' | translate }}
        </button>
        <button mat-flat-button color="accent" type="button" class="btn-accept" (click)="acceptAll()">
          {{ 'COOKIE_BANNER.ACCEPT_ALL' | translate }}
        </button>
      </div>
    </div>
  </aside>

  <!-- Preferences Modal Overlay -->
  <div class="preferences-overlay" *ngIf="showPreferences" (click)="closePreferences()">
    <div class="preferences-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" [attr.aria-label]="'COOKIE_BANNER.PREFERENCES_TITLE' | translate">
      <div class="preferences-header">
        <h2 class="preferences-title">{{ 'COOKIE_BANNER.PREFERENCES_TITLE' | translate }}</h2>
        <button mat-icon-button type="button" class="preferences-close" (click)="closePreferences()" aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="preferences-body">
        <!-- Functional Cookies (always active) -->
        <div class="preference-category">
          <div class="preference-row">
            <div class="preference-info">
              <h4>{{ 'COOKIE_BANNER.FUNCTIONAL_TITLE' | translate }}</h4>
              <p>{{ 'COOKIE_BANNER.FUNCTIONAL_DESC' | translate }}</p>
            </div>
            <div class="preference-status">
              <span class="badge-always-active">{{ 'COOKIE_BANNER.FUNCTIONAL_STATUS' | translate }}</span>
            </div>
          </div>
        </div>

        <mat-divider></mat-divider>

        <!-- Analytics Cookies -->
        <div class="preference-category">
          <div class="preference-row">
            <div class="preference-info">
              <h4>{{ 'COOKIE_BANNER.ANALYTICS_TITLE' | translate }}</h4>
              <p>{{ 'COOKIE_BANNER.ANALYTICS_DESC' | translate }}</p>
            </div>
            <div class="preference-toggle">
              <mat-slide-toggle [(ngModel)]="analyticsCookies" color="primary"></mat-slide-toggle>
            </div>
          </div>
        </div>

        <mat-divider></mat-divider>

        <!-- Marketing Cookies -->
        <div class="preference-category">
          <div class="preference-row">
            <div class="preference-info">
              <h4>{{ 'COOKIE_BANNER.MARKETING_TITLE' | translate }}</h4>
              <p>{{ 'COOKIE_BANNER.MARKETING_DESC' | translate }}</p>
            </div>
            <div class="preference-toggle">
              <mat-slide-toggle [(ngModel)]="marketingCookies" color="primary"></mat-slide-toggle>
            </div>
          </div>
        </div>
      </div>

      <div class="preferences-footer">
        <button mat-stroked-button type="button" class="btn-necessary" (click)="acceptNecessary()">
          {{ 'COOKIE_BANNER.NECESSARY_ONLY' | translate }}
        </button>
        <button mat-stroked-button type="button" class="btn-save" (click)="savePreferences()">
          {{ 'COOKIE_BANNER.SAVE_PREFERENCES' | translate }}
        </button>
        <button mat-flat-button color="accent" type="button" class="btn-accept" (click)="acceptAll()">
          {{ 'COOKIE_BANNER.ACCEPT_ALL' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
